export default "__VITE_ASSET__56425003__"